// Multi-language translations for Insubazaar
export const translations = {
  en: {
    nav: {
      home: "Home",
      compare: "Compare Quotes",
      whyUs: "Why ShopCompareInsure",
      financing: "Premium Financing",
      carriers: "Our Carriers",
      education: "Education",
      blog: "Blog",
      contact: "Contact",
      getQuote: "Get Quote"
    },
    hero: {
      title: "Secure Your Family's Legacy",
      subtitle: "Compare life insurance quotes from America's most trusted carriers",
      description: "Specialized in premium financing for high-net-worth families across South & Southeast Asia",
      cta: "Compare Life Insurance Quotes",
      secondaryCta: "Speak with a Specialist"
    },
    features: {
      compare: {
        title: "Compare & Save",
        description: "Access quotes from 13+ A+ rated carriers instantly"
      },
      financing: {
        title: "Premium Financing",
        description: "Preserve capital with sophisticated financing strategies"
      },
      global: {
        title: "Global Expertise",
        description: "Cultural fluency with Asian family values and needs"
      },
      trust: {
        title: "Confidential Advisory",
        description: "Unbiased guidance with complete discretion"
      }
    },
    cta: {
      compare: "Compare Life Insurance Quotes",
      speak: "Speak with a Specialist",
      explore: "Explore Premium Financing",
      request: "Request a Confidential Review",
      submit: "Submit",
      send: "Send Message"
    },
    footer: {
      disclaimer: "ShopCompareInsure is not an insurance carrier. Quotes are estimates for informational purposes only. Past performance is not indicative of future results. This website provides educational information and is not intended as tax, legal, or investment advice.",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  },
  hi: {
    nav: {
      home: "होम",
      compare: "कोट्स तुलना",
      whyUs: "क्यों ShopCompareInsure",
      financing: "प्रीमियम फाइनेंसिंग",
      carriers: "हमारे वाहक",
      education: "शिक्षा",
      blog: "ब्लॉग",
      contact: "संपर्क",
      getQuote: "कोट प्राप्त करें"
    },
    hero: {
      title: "अपने परिवार की विरासत सुरक्षित करें",
      subtitle: "अमेरिका के सबसे विश्वसनीय वाहकों से जीवन बीमा कोट्स की तुलना करें",
      description: "दक्षिण और दक्षिण पूर्व एशिया के उच्च-निवल मूल्य परिवारों के लिए प्रीमियम फाइनेंसिंग में विशेषज्ञता",
      cta: "जीवन बीमा कोट्स की तुलना करें",
      secondaryCta: "विशेषज्ञ से बात करें"
    },
    features: {
      compare: {
        title: "तुलना करें और बचाएं",
        description: "13+ A+ रेटेड वाहकों से तुरंत कोट्स प्राप्त करें"
      },
      financing: {
        title: "प्रीमियम फाइनेंसिंग",
        description: "परिष्कृत फाइनेंसिंग रणनीतियों से पूंजी बचाएं"
      },
      global: {
        title: "वैश्विक विशेषज्ञता",
        description: "एशियाई पारिवारिक मूल्यों की सांस्कृतिक समझ"
      },
      trust: {
        title: "गोपनीय सलाह",
        description: "पूर्ण विवेक के साथ निष्पक्ष मार्गदर्शन"
      }
    },
    cta: {
      compare: "जीवन बीमा कोट्स की तुलना करें",
      speak: "विशेषज्ञ से बात करें",
      explore: "प्रीमियम फाइनेंसिंग देखें",
      request: "गोपनीय समीक्षा का अनुरोध करें",
      submit: "जमा करें",
      send: "संदेश भेजें"
    },
    footer: {
      disclaimer: "ShopCompareInsure एक बीमा वाहक नहीं है। कोट्स केवल सूचनात्मक उद्देश्यों के लिए अनुमान हैं। पिछला प्रदर्शन भविष्य के परिणामों का संकेत नहीं है।",
      rights: "सर्वाधिकार सुरक्षित।",
      privacy: "गोपनीयता नीति",
      terms: "सेवा की शर्तें"
    }
  },
  te: {
    nav: {
      home: "హోమ్",
      compare: "కోట్స్ పోల్చండి",
      whyUs: "ఎందుకు ShopCompareInsure",
      financing: "ప్రీమియం ఫైనాన్సింగ్",
      carriers: "మా క్యారియర్లు",
      education: "విద్య",
      blog: "బ్లాగ్",
      contact: "సంప్రదింపు",
      getQuote: "కోట్ పొందండి"
    },
    hero: {
      title: "మీ కుటుంబ వారసత్వాన్ని భద్రపరచండి",
      subtitle: "అమెరికా యొక్క అత్యంత విశ్వసనీయ క్యారియర్ల నుండి జీవిత బీమా కోట్స్ పోల్చండి",
      description: "దక్షిణ & ఆగ్నేయ ఆసియా అధిక నికర విలువ కుటుంబాలకు ప్రీమియం ఫైనాన్సింగ్ లో నిపుణులు",
      cta: "జీవిత బీమా కోట్స్ పోల్చండి",
      secondaryCta: "నిపుణులతో మాట్లాడండి"
    },
    features: {
      compare: {
        title: "పోల్చి ఆదా చేయండి",
        description: "13+ A+ రేటెడ్ క్యారియర్ల నుండి తక్షణ కోట్స్"
      },
      financing: {
        title: "ప్రీమియం ఫైనాన్సింగ్",
        description: "అధునాతన ఫైనాన్సింగ్ వ్యూహాలతో మూలధనం కాపాడండి"
      },
      global: {
        title: "ప్రపంచ నైపుణ్యం",
        description: "ఆసియా కుటుంబ విలువలపై సాంస్కృతిక అవగాహన"
      },
      trust: {
        title: "గోప్య సలహా",
        description: "పూర్తి విచక్షణతో నిష్పక్షపాత మార్గదర్శకత్వం"
      }
    },
    cta: {
      compare: "జీవిత బీమా కోట్స్ పోల్చండి",
      speak: "నిపుణులతో మాట్లాడండి",
      explore: "ప్రీమియం ఫైనాన్సింగ్ అన్వేషించండి",
      request: "గోప్య సమీక్ష అభ్యర్థించండి",
      submit: "సమర్పించు",
      send: "సందేశం పంపండి"
    },
    footer: {
      disclaimer: "ShopCompareInsure బీమా క్యారియర్ కాదు. కోట్స్ సమాచార ప్రయోజనాల కోసం మాత్రమే అంచనాలు.",
      rights: "అన్ని హక్కులు రిజర్వ్ చేయబడ్డాయి.",
      privacy: "గోప్యతా విధానం",
      terms: "సేవా నిబంధనలు"
    }
  },
  gu: {
    nav: {
      home: "હોમ",
      compare: "ક્વોટ્સ સરખામણી",
      whyUs: "શા માટે ShopCompareInsure",
      financing: "પ્રીમિયમ ફાઇનાન્સિંગ",
      carriers: "અમારા કેરિયર્સ",
      education: "શિક્ષણ",
      blog: "બ્લોગ",
      contact: "સંપર્ક",
      getQuote: "ક્વોટ મેળવો"
    },
    hero: {
      title: "તમારા પરિવારનો વારસો સુરક્ષિત કરો",
      subtitle: "અમેરિકાના સૌથી વિશ્વસનીય કેરિયર્સમાંથી જીવન વીમા ક્વોટ્સની સરખામણી કરો",
      description: "દક્ષિણ અને દક્ષિણ પૂર્વ એશિયાના ઉચ્ચ-નેટવર્થ પરિવારો માટે પ્રીમિયમ ફાઇનાન્સિંગમાં નિષ્ણાત",
      cta: "જીવન વીમા ક્વોટ્સની સરખામણી કરો",
      secondaryCta: "નિષ્ણાત સાથે વાત કરો"
    },
    features: {
      compare: {
        title: "સરખામણી કરો અને બચાવો",
        description: "13+ A+ રેટેડ કેરિયર્સમાંથી તાત્કાલિક ક્વોટ્સ"
      },
      financing: {
        title: "પ્રીમિયમ ફાઇનાન્સિંગ",
        description: "અત્યાધુનિક ફાઇનાન્સિંગ વ્યૂહરચનાઓ સાથે મૂડી જાળવો"
      },
      global: {
        title: "વૈશ્વિક નિપુણતા",
        description: "એશિયન પારિવારિક મૂલ્યો પર સાંસ્કૃતિક સમજ"
      },
      trust: {
        title: "ગોપનીય સલાહ",
        description: "સંપૂર્ણ વિવેક સાથે નિષ્પક્ષ માર્ગદર્શન"
      }
    },
    cta: {
      compare: "જીવન વીમા ક્વોટ્સની સરખામણી કરો",
      speak: "નિષ્ણાત સાથે વાત કરો",
      explore: "પ્રીમિયમ ફાઇનાન્સિંગ શોધો",
      request: "ગોપનીય સમીક્ષાની વિનંતી કરો",
      submit: "સબમિટ કરો",
      send: "સંદેશ મોકલો"
    },
    footer: {
      disclaimer: "ShopCompareInsure વીમા કેરિયર નથી. ક્વોટ્સ માત્ર માહિતીના હેતુઓ માટે અંદાજો છે.",
      rights: "બધા હકો અનામત.",
      privacy: "ગોપનીયતા નીતિ",
      terms: "સેવાની શરતો"
    }
  }
};

export const languageNames = {
  en: "English",
  hi: "हिंदी",
  te: "తెలుగు",
  gu: "ગુજરાતી"
};
